import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import PermissionControls from './permissionsConfiguration/PermissionControls';
import CommonPermissionHeaders from './permissionsConfiguration/CommonPermissionHeaders';

const UPDATE_PERMISSION = 'UPDATE_PERMISSION';

const permissionReducer = (permission, action) => {
  switch (action.type) {
    case UPDATE_PERMISSION:
      return { ...permission, [action.payload.flagName]: action.payload.flagValue };
    default:
      throw new Error();
  }
};

export default function ProjectPermissionsConfiguration({
  initialPermission = {},
  inputNamePrefix = 'project_member',
  readOnly = false
}) {
  // Server should always provide complete permissions data via PermissionBlueprint
  const [permission, dispatch] = useReducer(permissionReducer, initialPermission);

  const updateFlag = (flagName, flagValue) => {
    if (readOnly) return;

    dispatch({
      type: UPDATE_PERMISSION,
      payload: {
        flagName,
        flagValue
      }
    });
  };

  return (
    <div className="project-permissions-configuration">
      <table className="table table-framed">
        <thead>
          <tr>
            <CommonPermissionHeaders />
          </tr>
        </thead>
        <tbody>
          <tr>
            {PermissionControls({
              permission,
              inputNamePrefix,
              updateFlag,
              readOnly
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
}

ProjectPermissionsConfiguration.propTypes = {
  initialPermission: PropTypes.object,
  inputNamePrefix: PropTypes.string,
  readOnly: PropTypes.bool
};